import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LayoutComponent } from "../layout/layout.component";
import {EndorseBranchOfficeComponent} from "./endorse-branch-office.component";

const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    children: [
      {
        path: 'endorse-branch-office',
        component: EndorseBranchOfficeComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EndorseBranchOfficeRoutingModule { }
